<div class="lh-lg list">
    <ul>
        @for (item of documents | splitStrings; track $index) {
            <li><a class="hover" (click)="openLink(item.subtitle)" rel="noopener noreferrer" target="_blank">{{item.title}}</a></li>
        }
    </ul>
</div>